export default {
  helpCenter: '帮助中心',
  downCenter: '下载专区',
  newMemberGuide: '新手入门',
  productExperience: '产品体验',
  experience: '体验',
  feedback: '轻云社区',
  productProfile: '产品介绍',
  quicklyUnderstand: '了解',
  operationGuide: '操作指南',
  quickLearning: '上手',
  userDeriction: '使用',
  vedioCourse: '视频教程',
  case: '案例',
  userCase: '用户案例',
  basicOperation: '基本操作',
  experienceAccount: '体验账号',
  search: '搜索',
  searchPlaceholder: '请输入您的疑问，如：如何更换终端镜像？',
  noDataTips: '很抱歉，未找到相关结果……',
  onlineService: '在线客服',
  resolveTip: '您也可以尝试以下方式解决：',
  resolveMethod1: '方式1:通过{link}下载操作手册到本地，查找相关内容。',
  resolveMethod2: '方式2:通过{link}将您的需求反馈给我们，我们会尽快完善。',
  resolveMethod3: '方式3:通过{link}咨询相关问题，客服同学会为您解答。',
  backToIndex: '返回帮助中心首页',
  public: '{time} 发布',
  all: '全部',
  searchPlacehoder2: '请输入您的疑惑',
  downloadImage: '下载镜像',
  preview: '预览',
  contact: '联系我们',
  onlineContact: '在线咨询',
  focusRclNumber: '关注锐捷轻云公众号',
  protect: '维保查询',
  fix: '自助报修',
  rclHelpCenter: '轻云帮助中心',
  download: '下载',
  rjRclMicroCode: '锐捷轻云小程序',
  rjOfficailAccountCode: '锐捷轻云公众号',
  more: '更多',
  picTxt: '图文',
  vedio: '视频',
  hot: '热门',
  productUse: '产品使用'
}
